import { Component } from '@angular/core';
import { ApiService } from '../../shared/services/api.service';

@Component({
  standalone: false,
  selector: 'app-settings',
  templateUrl: './settings.component.html',
  styleUrl: './settings.component.scss'
})
export class SettingsComponent {

  bankStatus: any = {
    andariaApi: false,
    hnbApi: false
  };

  constructor(private _apiService: ApiService) {

  }

  ngOnInit() {
    const vm = this;
    vm._apiService.getData('/common/bankStatus').subscribe((res: any) => {
      if (res && !res.error) {
        vm.bankStatus = res.data;
      }
    });
  }

  toggleBank(key: string) {
    const vm = this;
    vm.bankStatus[key] = !vm.bankStatus[key];
    const body = {
      data: vm.bankStatus
    };
    vm._apiService.postData('/common/setBankStatus', body).subscribe((res: any) => {
      console.log('Updated:', res);
    });
  }

}
